export default __webpack_public_path__ + "static/media/LENS_CULINARIS_ATHILA_4.50a04963.jpg";